import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-workshop-jobcard-group-jobs-modal',
  templateUrl: './workshop-jobcard-group-jobs-modal.component.html',
  styleUrls: ['./workshop-jobcard-group-jobs-modal.component.scss']
})
export class WorkshopJobcardGroupJobsModalComponent {
  
  public deleting: boolean = false;

    constructor(
      public activeModal: NgbActiveModal,
      private translate: TranslateService
    ) { 

    }

    groupJobs() {
      this.activeModal.close({groupJobs : true})
    }
    cancel() {
      this.activeModal.dismiss('cancel');
    }
}
